import axios from 'axios';
import { getCsrftoken } from '../../helpers/csfrToken';
import { restErrorHandler } from '../../helpers/restErrorHandler';
import { RestApiState } from '../../interfaces/Rest/types';

type Building = {
    id: number,
    building_name: string | null;
}

type Device = {
    id: number
    device_name: string | null;
}

export interface Orgs {
    id: number;
    organization_name: string
}


export interface Acb {
    building_id: number | null;
    client_device_type: number | null;
    custom_name: string | null;
    customer_comment: string | null;
    serial_number: string;
    buildings: Building[]
    devices: Device[]
}

export interface AcbOrg {
    serial_number: string | null;
    organization_id: number | null;
    organizations: Orgs[]
}

export interface AcbOrgPatch {
    serial_number: string;
    organization_id: number | null;
}

export type AcbPatch = {
    building_id?: number;
    client_device_type?: number;
    custom_name?: string;
}


export interface AcbProps {
    role: string;
    setStatus: (value: any) => void;
    setValue: (value: any) => void;
    device: Acb;
}



export const AxiosGetAcb = (
    role: string, 
    serial_number: string, 
    setValue: (value:any) => void
) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }

    axios.get<Acb>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serial_number}/edit`, headers)
        .then(response => {
            if (response.status === 200) {
                try {
                    setValue(response.data)
                } catch {
                    console.log('err')
                }
            }
        })
        .catch(error => {
            restErrorHandler(error.status)
        });
}

export const AxiosPatchAcb = (
    role: string, 
    serial_number: string,
    data: AcbPatch,
    setValue: (value:any) => void,
    setStatus: (value: any) => void
) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.patch<Acb>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serial_number}/edit`, data, headers)
        .then(response => {
            if (response.status === 200) {
                try {
                    setValue(response.data)
                    setStatus(RestApiState.Success)
                } catch {
                    setStatus(RestApiState.BadRequest)
                }
            }
        })
        .catch(error => {
            // restErrorHandler(error.status)
            console.log(error)
        });
}



export const AxiosGetAcbOrg = (
    role: string, 
    serial_number: string, 
    setValue: (value:any) => void
) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }

    axios.get<Acb>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serial_number}/change-organization`, headers)
        .then(response => {
            if (response.status === 200) {
                try {
                    setValue(response.data)
                } catch {
                    console.log('err')
                }
            }
        })
        .catch(error => {
            restErrorHandler(error.status)
        });
}

export const AxiosPatchAcbOrg = (
    role: string, 
    serial_number: string,
    data: AcbOrgPatch,
    setValue: (value:any) => void,
    setStatus: (value: any) => void
) => {
    const headers = {
        headers: {
            'X-CSRFToken': getCsrftoken(),
            'Content-Type': 'multipart/form-data'
        },
        withCredentials: true        
    }
    axios.patch<Acb>(`${process.env.REACT_APP_DJANGO_SERVER_URL}/api/${role}/v1/acb/${serial_number}/change-organization`, data, headers)
        .then(response => {
            if (response.status === 200) {
                try {
                    setValue(response.data)
                    setStatus(RestApiState.Success)
                } catch {
                    setStatus(RestApiState.BadRequest)
                }
            }
        })
        .catch(error => {
            // restErrorHandler(error.status)
            console.log(error)
        });
}